import { render } from "./CardCreatorOwnerImage.vue?vue&type=template&id=172eb61c&scoped=true"
import script from "./CardCreatorOwnerImage.vue?vue&type=script&lang=js"
export * from "./CardCreatorOwnerImage.vue?vue&type=script&lang=js"

import "@/Common/Styles/nftCard.scss?vue&type=style&index=0&id=172eb61c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172eb61c"]])

export default __exports__